import React, { createContext, useEffect, useState } from 'react';
// create a context
const CartContext =createContext();
const CartProvider = ({children}) => {
  // cartState
  const [cart,setCart]= useState([]);
  // itemAmount state
  const [itemAmount,setItemAmount] =useState(0) ;
  // total price state
  const [total,setTotal]=useState(0);

  // add to cart
  const addToCart =(product,id)=>
  {
    const newItem = {...product,amount:1}
    // check if the item is already in the cart
    const cartItem = cart.find(((item)=>
    {
      return item.id === id;
    }))
    // if the item is already in the cart
    if (cartItem){
      const newCart = [...cart].map(item=>
        {
          if(item.id === id){
            return {...item,amount: cartItem.amount + 1}
          }else{
            return item;
          }
        });
        setCart(newCart);
    }
   else{
    setCart([...cart,newItem])
   }
  }

  //  console.log(cart);
  // remove from cart
  const removeFromCart =(id)=>
  {
    const newCart = cart.filter(item=>
      {
        return item.id !== id 
      })
      setCart(newCart)
  }
// clearing the cart
  const clearCart =()=>
  {
    setCart([]);

  }
  // increase the amount
  const increaseAmount =(id)=>
  {
    // console.log(`amount ${id} increased`);
    const item = cart.find((item)=> item.id === id);
    addToCart(item,id);
  }
  // decrease the amount
  const decreaseAmount =(id)=>
  {
    const cartItem = cart.find((item)=> {
      return item.id === id;
    });
  if(cartItem){
    const newCart = cart.map((item)=>
    {
      if (item.id === id){
        return {...item,amount:cartItem.amount - 1}
      }
      else {
        return item;
      }
    });
    setCart(newCart);
  }
  
    if (cartItem.amount <2) {
      removeFromCart(id);
    }
    // console.log(`amount ${id} decreased`);
  }
  // updating the cart 
  useEffect(()=>
  {
    if(cart){
      const amount =cart.reduce((accumulator,currentItem)=>
      {
        return accumulator + currentItem.amount;
      },0);
      setItemAmount(amount);
    }
  })
  // updating the total
  useEffect(()=>{
    const total = cart.reduce((accumulator,currentItem)=>
    {
      return accumulator + currentItem.price * currentItem.amount;
    },0);
    setTotal(total)
  })

  return <CartContext.Provider value={{
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    increaseAmount,
    decreaseAmount,
    itemAmount,
    total
    }}>
{children}
    </CartContext.Provider>;
};

export  {CartProvider,CartContext};
